import { jsx } from "react/jsx-runtime";
import React from "react";
var arrow_right_from_base_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { d: "M12 22H3V2h9v2H5v16h7v2z" }), /* @__PURE__ */ jsx("path", { d: "m16.1715 11-3.2429-3.243 1.4142-1.4142 5.6568 5.6568-5.6568 5.6569-1.4142-1.4142L16.1708 13H7.9999v-2h8.1716z" })];
};
export {
  arrow_right_from_base_default as default
};
